import { useEffect, useState } from "react";
import { firebaseArtTest, firebaseArtProd, firebaseArtStaging } from "./config/firebase";

import styles from "styles/App.module.css";

import ILPMain from "./components/container/ILPMain";
// import WebSocketContextProvider from "contexts/WebSocketContextProvider";
import { initSocketService } from 'config/socket/socketUtil'

import big from 'assets/images/common/big.svg'
import small from 'assets/images/common/small.svg'

type ilpInitialState = {
  student: { id: string; name: string };
  teacher: { id: string; name: string };
  isTeacher: boolean;
};

const defaultInitialPropsData: ilpInitialState = {
  student: {
    id: (Math.random() * 0xfffff * 1000000).toString(16).slice(0, 10),
    name: "Jake",
  },
  teacher: { id: "adfad", name: "Alice" },
  isTeacher: true,
};

const currentLecture = "IN-EN-GG2-AAV-TRIAL-LPD-M1"
// const dependencyLecture = ""

function App() {
  const [initialProps, setInitialProps] = useState<ilpInitialState>();
  const [firebaseRef, setFirebaseRef] = useState<any>();
  // const [prevLessonFirebaseRef, setPrevLessonFirebaseRef] = useState<any>()
  const [firebaseStorage, setFirebaseStorage] = useState<any>();
  const [studentNickNameRef, setStudentNickNameRef] = useState<any>();

  const [authtoken, setAuthToken] = useState<string>("");
  const [userToken, setUserToken] = useState<string>("");
  const [firebaseToken, setFirebaseToken] = useState<string>("");

  const [isProdMode, setIsProdMode] = useState<boolean>(false);
  const [isStagingMode, setIsStagingMode] = useState<boolean>(false);
  const [isDevelopment, setIsDevelopment] = useState<boolean>(false);

  const [ socketInstance, setSocketInstance ] = useState<any>()

  const [iframePropsReceived, setIframePropsReceived] =
    useState<boolean>(false);
  const [iframeProps, setIframeProps] = useState<any>({});

  const isInIframe = window.self !== window.top;

  useEffect(() => {
    window.addEventListener("message", init);
    return () => window.removeEventListener("message", init);
  }, []);

  function init(e: any) {
    const data = e.data;
    const parsedData = data;

    const {
      token,
      userAuthToken,
      firebaseAuthToken,
      student,
      teacher,
      isTeacher,
      isProduction = false,
      isStaging = false,
      isDevelopment = false,
      message,
    } = parsedData;

    if (message === "initialProps") {
      setInitialProps({ student, teacher, isTeacher });
      // setAuthToken(token);
      setFirebaseToken(firebaseAuthToken || token)
      setUserToken(userAuthToken)
      setIsProdMode(isProduction);
      setIsStagingMode(isStaging)
      setIsDevelopment(isDevelopment);
      setIframePropsReceived(true);
      setIframeProps(parsedData);
    }
  }

  useEffect(() => {
    if (isInIframe) {
      if (isProdMode) {
        firebaseArtProd
          .auth()
          .signInWithCustomToken(firebaseToken)
          .then(() => {
            if (initialProps) {
              const firebaseStore = firebaseArtProd.firestore();
              const firebaseStorage = firebaseArtProd.storage();
              const studentId = initialProps.student.id;
              if (firebaseStore) {
                const firebaseRef = firebaseStore
                  .collection("students")
                  .doc(studentId.trim())
                  .collection("lesson-presentation")
                  .doc(currentLecture);

                  const studentNameRef = firebaseStore
                  .collection("students")
                  .doc(studentId.trim());
                  
                  
                setStudentNickNameRef(studentNameRef);

                setFirebaseRef(firebaseRef);

                // const prevRef = firebaseStore
                //   .collection("students")
                //   .doc(studentId.trim())
                //   .collection("lesson-presentation")
                //   .doc(dependencyLecture);

                // setPrevLessonFirebaseRef(prevRef)

                setFirebaseStorage(firebaseStorage)
              }
              console.log("USERCREDS: Authenticated succesfully...");
            }
          })
          .catch((error: any) => {
            console.log("USERCREDS:", error);
          });
      }

      if (isStagingMode) {
        firebaseArtStaging
          .auth()
          .signInWithCustomToken(firebaseToken)
          .then(() => {
            if (initialProps) {
              const firebaseStore = firebaseArtStaging.firestore();
              const firebaseStorage = firebaseArtStaging.storage();
              const studentId = initialProps.student.id;
              if (firebaseStore) {
                const firebaseRef = firebaseStore
                  .collection("students")
                  .doc(studentId.trim())
                  .collection("lesson-presentation")
                  .doc(currentLecture);

                setFirebaseRef(firebaseRef);

                // const prevRef = firebaseStore
                //   .collection("students")
                //   .doc(studentId.trim())
                //   .collection("lesson-presentation")
                //   .doc(dependencyLecture);

                // setPrevLessonFirebaseRef(prevRef)
                const studentNameRef = firebaseStore
                .collection("students")
                .doc(studentId.trim());
                
                
                setStudentNickNameRef(studentNameRef);

                setFirebaseStorage(firebaseStorage)
              }
              console.log("USERCREDS: Authenticated succesfully...");
            }
          })
          .catch((error: any) => {
            console.log("USERCREDS:", error);
          });
      }

      if (isDevelopment) {
        if (initialProps) {
          let firebaseStore = firebaseArtTest.firestore();
          let firebaseStorage = firebaseArtTest.storage();
          const studentId = initialProps.student.id;

          const firebaseRef = firebaseStore
            .collection("students")
            .doc(studentId.trim())
            .collection("lesson-presentation")
            .doc(currentLecture);

          setFirebaseRef(firebaseRef);

          // const prevRef = firebaseStore
          //   .collection("students")
          //   .doc(studentId.trim())
          //   .collection("lesson-presentation")
          //   .doc(dependencyLecture);

          // setPrevLessonFirebaseRef(prevRef)
          const studentNameRef = firebaseStore
          .collection("students")
          .doc(studentId.trim());
          
          
        setStudentNickNameRef(studentNameRef);

          setFirebaseStorage(firebaseStorage)
        }
      }
    } else {
      let firebaseStore = firebaseArtTest.firestore()
      let firebaseStorage = firebaseArtTest.storage();

      const studentId = defaultInitialPropsData.student.id;
      const firebaseRef = firebaseStore
        .collection("students")
        .doc(studentId.trim())
        .collection("lesson-presentation")
        .doc(currentLecture);
      setInitialProps(defaultInitialPropsData);
      setFirebaseRef(firebaseRef);

      // const prevRef = firebaseStore
      //   .collection("students")
      //   .doc(studentId.trim())
      //   .collection("lesson-presentation")
      //   .doc(dependencyLecture);

      // setPrevLessonFirebaseRef(prevRef)
      const studentNameRef = firebaseStore
      .collection("students")
      .doc(studentId.trim());
      
      
    setStudentNickNameRef(studentNameRef);

      setFirebaseStorage(firebaseStorage)
    }
  }, [iframePropsReceived, initialProps, isProdMode]);

  useEffect(() => {
    if(initialProps) {
      const sInstance = initSocketService({
        roomId: `${currentLecture}${initialProps.student.id}` as any,
        studentId: initialProps.student.id as any,
        teacherId: initialProps.teacher.id as any,
        mode: initialProps.isTeacher ? 'teacher' : 'student' as any,
        connectCb: '() => {}' as any,
        cb: '() => {}' as any,
        socketToken: btoa(JSON.stringify({
              uid: initialProps.isTeacher ? initialProps.teacher.id : initialProps.student.id,
              roomId: `${currentLecture}${initialProps.student.id}`
          })) as any
      })
      setSocketInstance(sInstance)
    }
  }, [initialProps])

  return (
    <div className={styles.app}>
      {/* {firebaseRef && prevLessonFirebaseRef && initialProps ? ( */}
      {firebaseRef && initialProps && socketInstance && studentNickNameRef ? (
       <ILPMain
          ilpProps={initialProps}
          firebaseRef={firebaseRef}
          // prevLessonFirebaseRef={prevLessonFirebaseRef}
          firebaseStorage={firebaseStorage}
          iframeProps={iframeProps}
          currentLecture={currentLecture}
          socketInstance={socketInstance}
          studentNickNameRef={studentNickNameRef}
        />
      ) : (
        <div>Loading....</div>
      )}
      <img
        src={big}
        alt='lefttree'
        className={styles.leftTree}
      />
      <img
        src={small}
        alt='lefttree'
        className={styles.rightTree}
      />
    </div>
  );
}

export default App;
